export default {
  employee_contact_information_page_description:
    'Vær opmærksom på, at det kun er andre medarbejdere, der kan se dit arbejdstelefonnummer. Hvis du har angivet en e-mail, kan den ikke ses af andre brugere i Aula. E-mailen bruges kun i forbindelse med e-mail-notifikationer.',
  work_number: 'Arbejde',
};
